import { ILanguage } from '../../interface';

const ar: ILanguage = {
  locale: 'ar',
  translations: {
    notifications: 'إشعارات',
    markAllAsRead: 'وضع علامة على الكل كمقروءة',
    noNotificationsTitle: 'لا توجد إخطارات حتى الآن',
    noNotificationsDescription: 'سنخبرك عندما نحصل على شيء جديد لك.',
    pinned: 'مثبت',
    markAsUnread: 'وضع علامة كغير مقروءة',
    markAsRead: 'وضع علامة كمقروءة',
    archive: 'أرشيف',
    expiresIn: 'تنتهي في',
    minute: 'دقيقة',
    minutes: 'دقائق',
    hour: 'ساعة',
    hours: 'ساعات',
    day: 'يوم',
    days: 'أيام',
    week: 'أسبوع',
    weeks: 'أسابيع',
    month: 'شهر',
    months: 'أشهر',
    year: 'سنة',
    years: 'سنوات',
  },
};

export default ar;
